import { render } from "./popup-cart.vue?vue&type=template&id=5f4cb94a"
import script from "./popup-cart.vue?vue&type=script&lant=ts&lang=js"
export * from "./popup-cart.vue?vue&type=script&lant=ts&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__